export default "__VITE_ASSET__DI38IR5v__"